/** Códigos internos tras validar registro (auth + RPC). */
export const REGISTRO_EMAIL_EN_USO = 'REGISTRO_EMAIL_EN_USO';
export const REGISTRO_TELEFONO_EN_USO = 'REGISTRO_TELEFONO_EN_USO';

const MSG_EMAIL = 'Este email está asociado a una cuenta.';
const MSG_TELEFONO = 'Este número de teléfono está asociado a una cuenta.';

export function registroDuplicadoMessage(error: unknown): string | null {
  const raw = error instanceof Error ? error.message : String(error ?? '');
  const msg = raw.trim();

  if (msg === REGISTRO_TELEFONO_EN_USO) return MSG_TELEFONO;

  if (msg === REGISTRO_EMAIL_EN_USO) return MSG_EMAIL;

  const lower = msg.toLowerCase();
  if (
    lower.includes('already registered') ||
    lower.includes('already exists') ||
    lower.includes('user already') ||
    lower.includes('email address is already registered') ||
    lower.includes('email already registered')
  ) {
    return MSG_EMAIL;
  }

  // No usar el nombre de la RPC aquí: si falla (no desplegada, red, permisos), el mensaje lo incluye y sería un falso positivo.
  if (
    lower.includes('idx_user_profiles_telefono_unique') ||
    (lower.includes('duplicate key') && lower.includes('telefono')) ||
    (lower.includes('unique constraint') && lower.includes('telefono'))
  ) {
    return MSG_TELEFONO;
  }

  return null;
}
